import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";

const URL_API = process.env.URL_API;
const resetURL = `${URL_API}/identity/suppliers/reset-password`;

export interface ResetResult {
    data: any[];
}

export const choosePasswordApi = createAsyncThunk(
    'user/choosePassword',
    async (account: any, { rejectWithValue }) => {
        try {
            const { data } = await axios.post<ResetResult>(resetURL, account);

            return data;
        } catch (error) {
            // @ts-ignore
            return rejectWithValue(error.response.data)
        }
    }
);